import React from 'react';
import { useModalDismiss } from '../../hooks/useModalDismiss';

interface ConfirmImportDuplicateModalProps {
  bookTitle: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmImportDuplicateModal({ bookTitle, onConfirm, onCancel }: ConfirmImportDuplicateModalProps) {
  const dismiss = useModalDismiss(onCancel);
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'var(--modal-mask)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1001,
      backdropFilter: 'blur(4px)'
    }} {...dismiss}>
      <div style={{
        backgroundColor: 'var(--card-bg)', padding: 32, borderRadius: 24, width: 420,
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', color: 'var(--text-color)'
      }}>
        <div style={{ fontSize: 32, marginBottom: 16 }}>⚠️</div>
        <h2 style={{ marginBottom: 12, fontSize: 18, fontWeight: 800 }}>作品已存在</h2>
        <p style={{ marginBottom: 24, color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.6 }}>
          作品名称 <span style={{ color: 'var(--primary-color)', fontWeight: 700 }}>"{bookTitle}"</span> 已存在于您的作品列表中。<br />
          您可以导入此作品并为其重新命名。
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <button
            onClick={onCancel}
            style={{
              padding: '12px 24px', backgroundColor: 'transparent', color: 'var(--text-secondary)',
              border: 'none', borderRadius: 12, cursor: 'pointer', fontSize: 15, fontWeight: 600
            }}
          >
            不导入
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '12px 32px', backgroundColor: 'var(--primary-color)', color: 'white',
              border: 'none', borderRadius: 12, cursor: 'pointer', fontSize: 15, fontWeight: 700,
              boxShadow: '0 10px 15px -3px rgba(24, 144, 255, 0.4)'
            }}
          >
            继续导入
          </button>
        </div>
      </div>
    </div>
  );
}
